import { useEffect, useState } from "react";

import { message } from "antd";

import api from "services/api.service";

export interface ISharedStorageMeta {
  max_drive_size: number;
  used_drive_size: number;
}

export const useSharedStorageMeta = () => {
  const [ meta, setMeta ] = useState<ISharedStorageMeta | null>(null);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ error, setError ] = useState(false);

  const getSharedStorageMeta = async () => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await api.getSharedStorageMeta();

      if (response.data) {
        setMeta(response.data);
      } else {
        setError(true);
        message.error("Failed to load storage meta information");
      }
    } catch (err) {
      setError(true);
      message.error("Something went wrong while loading storage meta information!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSharedStorageMeta();
  }, []);

  return {
    meta,
    isLoading,
    error,
    refetch: getSharedStorageMeta,
  };
};
